// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3qlgNh0c clearfix","list":"list-ZPT3as67","pd15":"pd15-1wCX_sZZ clearfix","xs_word_02":"xs_word_02-3VR5pa2b","qqg":"qqg-2CKLOcL2"};